<template>

<div class="main" id="detail-4473">
	<div class="page-header">
		<div>
			<img v-if="logoSrc" :src="logoSrc">
			<div v-else>{{ getClient.company_name }}</div>
		</div>
		<h1>Firearms Transaction Record, Form 4473</h1>
	</div>

	<div class="login" v-if="!user.user_name" v-cloak>
		<h2>Manager Login</h2>
    	<div class="content">
			<label>Username</label>
			<input type="text" v-model="username">
			<label>Password</label>
			<input type="password" v-model="password" @keyup.enter="doLogin">
		</div>
		<div class="controls">
			<div class="button action" @click="doLogin">Log In</div>
			<span class="loading" v-if="loading"><i class="fas fa-spinner fa-spin"></i></span>
		</div>
		<div class="message">{{ message }}</div>
		<!-- <router-link to="/logbooks/customer-4473-legacy" class="note">Need a Recertification Signature for an older form?</router-link> -->
	</div>

	<div class="form-options" v-else-if="!formOption" v-cloak>
		<div class="options">
			<h2>Customer Section B</h2>
			<label style="margin: 0 0 1em 0;">Find a 4473 with Dealer Section A completed so the transferee / buyer can complete Section B...</label>
			<div class="input-with-control">
				<input type="text" v-model="search_section_a_text" placeholder="Search 4473s by customer..." @keyup.enter="searchForms('A')">
				<div class="button action input-go" @click="searchForms('A')"><i class="fas fa-search"></i></div>
			</div>
			<div class="search-result bordered">
				<ul v-if="sectionAForms && sectionAForms.length != 0" class="search-list">
					<li class="clickable-list-item" v-for="(sectionAForm, index) in sectionAForms" @click="assignForm(sectionAForm)" :key="index">
						<span>{{ sectionAForm.contact_data.full_name || $fullName(sectionAForm.contact_data) }}</span>
						<span>{{ sectionAForm.contact_data.address_1 }}</span>
						<span>{{ sectionAForm.contact_data.city }}, {{ sectionAForm.contact_data.state }} {{ sectionAForm.contact_data.zip_code }}</span>
						<span v-if="sectionAForm.contact_data.ffl_number">{{ sectionAForm.contact_data.ffl_number }}</span>
						<div>
							<span class="label">Created</span>{{ sectionAForm.date_created }}
							<span class="label">Firearms</span>{{ sectionAForm.form_data.section_a.firearms_list[0].manufacturer + ' ' + sectionAForm.form_data.section_a.firearms_list[0].serial_number }}
							{{ sectionAForm.form_data.section_a.firearms_list.length > 1 ? ' and ' + (sectionAForm.form_data.section_a.firearms_list.length - 1) + ' more' : '' }}
						</div>
					</li>
				</ul>
				<div v-else-if="searchMessageSectionA" class="no-results">{{ searchMessageSectionA }}</div>
			</div>
		</div>
		<div class="options">
			<h2>Customer Section D</h2>
			<label style="margin: 0 0 1em 0;">Find a 4473 with Dealer Section C completed so the transferee / buyer can sign and date Section D...</label>
			<div class="input-with-control">
				<input type="text" v-model="search_section_c_text" placeholder="Search 4473s by customer..." @keyup.enter="searchForms('C')">
				<div class="button action input-go" @click="searchForms('C')"><i class="fas fa-search"></i></div>
			</div>
			<div class="search-result bordered">
				<ul v-if="sectionCForms && sectionCForms.length != 0" class="search-list">
					<li class="clickable-list-item" v-for="(sectionCForm, index) in sectionCForms" @click="assignForm(sectionCForm)" :key="index">
						<span>{{ sectionCForm.contact_data.full_name || $fullName(sectionCForm.contact_data) }}</span>
						<span>{{ sectionCForm.contact_data.address_1 }}</span>
						<span>{{ sectionCForm.contact_data.city }}, {{ sectionCForm.contact_data.state }} {{ sectionCForm.contact_data.zip_code }}</span>
						<span v-if="sectionCForm.contact_data.ffl_number">{{ sectionCForm.contact_data.ffl_number }}</span>
						<div>
							<span class="label">Created</span>{{ sectionCForm.date_created }}
							<span class="label">Firearms</span>{{ sectionCForm.form_data.section_a.firearms_list[0].manufacturer + ' ' + sectionCForm.form_data.section_a.firearms_list[0].serial_number }}
							{{ sectionCForm.form_data.section_a.firearms_list.length > 1 ? ' and ' + sectionCForm.form_data.section_a.firearms_list.length + ' more' : '' }}
						</div>
					</li>
				</ul>
				<div v-else-if="searchMessageSectionC" class="no-results">{{ searchMessageSectionC }}</div>
			</div>
		</div>

		<div v-if="clientHasVariance" class="extra-options" style="margin: 1.5em 0 0 0;">
			<p style="text-align: center;"><span class="get-correct-pending-link" @click="getCorrectPendingForms()">Need to correct a customer Section B?</span></p>
			<div v-if="gettingCorrectPendingForms" class="search-result bordered">
				<ul v-if="correctPendingForms && correctPendingForms.length != 0" class="search-list">
					<li class="clickable-list-item" v-for="(correctPendingForm, index) in correctPendingForms" @click="assignForm(correctPendingForm)" :key="index">
						<span>{{ correctPendingForm.contact_data.full_name || $fullName(correctPendingForm.contact_data) }}</span>
						<span>{{ correctPendingForm.contact_data.address_1 }}</span>
						<span>{{ correctPendingForm.contact_data.city }}, {{ correctPendingForm.contact_data.state }} {{ correctPendingForm.contact_data.zip_code }}</span>
						<span v-if="correctPendingForm.contact_data.ffl_number">{{ correctPendingForm.contact_data.ffl_number }}</span>
						<div>
							<span class="label">Created</span>{{ correctPendingForm.date_created }}
							<span class="label">Firearms</span>{{ correctPendingForm.form_data.section_a.firearms_list[0].manufacturer + ' ' + correctPendingForm.form_data.section_a.firearms_list[0].serial_number }}
							{{ correctPendingForm.form_data.section_a.firearms_list.length > 1 ? ' and ' + correctPendingForm.form_data.section_a.firearms_list.length + ' more' : '' }}
						</div>
					</li>
				</ul>
				<div v-else-if="searchMessageCorrectPending" class="no-results">{{ searchMessageCorrectPending }}</div>
			</div>
		</div>

		<div class="extra-options" style="margin: 1em 0 0 0;">
			<div class="button action" @click="doLogout()">Log Out</div>
		</div>

	</div>

	<div v-else-if="formIncomplete" v-cloak class="main-form-container" id="main-form-container">

        <div class="form section-a">
            <h2 class="section-title">Section A - Must Be Completed By Transferor/Seller Before Transferee/Buyer Completes Section B</h2>
            <div class="firearms form-line">
                <div class="firearms-list header">
	                <div class="cell form-header">1.<div class="note">Manufacturer and Importer (If any) (If the manufacturer and importer are different, the FFL must include both.)</div></div>
	                <div class="cell form-header">2.<div class="note">Model<br>(If Designated)</div></div>
	                <div class="cell form-header">3.<div class="note">Serial Number</div></div>
	                <div class="cell form-header">4.<div class="note">Type</div></div>
	                <div class="cell form-header">5.<div class="note">Caliber or Gauge</div></div>
				</div>
                <div class="firearms-list" v-for="(firearm, index) in form.form_data.section_a.firearms_list" :key="index">
                    <div class="cell"><label class="inline-block">{{ index + 1 }}.</label><input type="text" disabled v-model="firearm.manufacturer"></div>
                    <div class="cell"><input type="text" disabled v-model="firearm.model"></div>
                    <div class="cell"><input type="text" disabled v-model="firearm.serial_number"></div>
                    <div class="cell"><input type="text" disabled v-model="firearm.gun_type"></div>
                    <div class="cell"><input type="text" disabled v-model="firearm.caliber"></div>
                </div>
            </div>
            <!-- /.firearms -->
            <div class="form-line two-columns">
				<div>
                	<div>6. Total Number of Firearms Transferred (Please handwrite by printing e.g., zero, one, two, three, etc. Do not use numerals.)</div>
                	<input type="text" disabled v-model="form.form_data.section_a.total_firearms_transferred" readonly>
				</div>
				<div>
					<div class="three-one-columns">
		                <div>7. Check if any part of this transaction is a pawn redemption.</div>
		                <label class="checkbox with-outside-label">
		                    <input type="checkbox" disabled id="nics_buyer_exempt" v-model="form.form_data.section_a.transaction_pawn_redemption">
		                    <span class="disabled"><i class="fas fa-check-circle"></i></span>
		                </label>
					</div>
					<div class="three-one-columns">
		                <label style="text-align: right; padding: 0.5em 0 0 0;">Record Line Number(s) From Question 1 Above:</label>
	                    <input type="text" disabled v-model="form.form_data.section_a.transaction_pawn_redemption_line_numbers">
					</div>
				</div>
				<div class="three-one-columns">
	                <div>8. Check if this transaction is to facilitate a private party transfer.</div>
	                <label class="checkbox with-outside-label">
	                    <input type="checkbox" disabled v-model="form.form_data.section_a.private_party_transfer">
	                    <span class="disabled"><i class="fas fa-check-circle"></i></span>
	                </label>
				</div>
            </div>
        </div>

		<div class="form section-b">
            <h2 class="section-title">Section B - Must Be Completed Personally By Transferee/Buyer</h2>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('B') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('B')"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf('B') > -1">
                    <p>Section B</p>

                    <p>The transferee/buyer must personally complete Section B of this form and certify (sign and date) that the answers are true, correct, and complete. However, if the transferee/buyer is unable to read and/or write, the answers (other than the signature) may be completed by another person, excluding the transferor/seller. Two persons (other than the transferor/seller) must then sign as witnesses to the transferee’s/ buyer’s answers and signature/certification in question 22.</p>

                    <p>When the transferee/buyer of a firearm is a corporation, company, association, partnership, or other such business entity, an officer authorized to act on behalf of the business must complete Section B of the form with his/her personal information, sign Section B, and attach a written statement, executed under penalties of perjury, stating: (A) the firearm is being acquired for the use of and will be the property of that business entity; and (B) the name and address of that business entity.</p>
                </div>
            </div>

            <div class="form-line">9. Transferee’s/Buyer’s Full Name (If legal name contains an initial only, record the initial followed by “IO” in quotes. If no middle initial or name, record “NMN”.)</div>

            <div class="form-line two-columns">
                <div class="three-two-columns" style="grid-template-columns: 3fr 1fr 1fr;">
                    <label id="last_name" class="span-three" for="last_name">Last Name (including suffix, e.g., Jr, Sr, II, III)</label>
                    <input name="last_name" type="text" v-model="form.form_data.section_b.last_name" ref="last_name" :disabled="sectionBComplete || capturingSignature">
					<select name="suffix" id="suffix" v-model="form.form_data.section_b.suffix" :disabled="sectionBComplete || capturingSignature">
						<option value="">Suffix...</option>
						<!-- <option v-for="(code, value) in getEnicsCadenceCodes" :value="code">{{ value }}</option> -->
						<option value="II" title="">II</option>
						<option value="III" title="">III</option>
						<option value="IV" title="">IV</option>
						<option value="V" title="">V</option>
						<option value="VI" title="">VI</option>
						<option value="VII" title="">VII</option>
						<option value="VIII" title="">VIII</option>
						<option value="IX" title="">IX</option>
						<option value="X" title="">X</option>
						<option value="JR" title="">Jr</option>
						<option value="SR" title="">Sr</option>
					</select>
                    <label class="checkbox" id="last_initial">
                        <input type="checkbox" v-model="form.form_data.section_b.last_initial" :disabled="sectionBComplete || capturingSignature">
                        <span :class="{disabled: sectionBComplete || capturingSignature}"><i class="fas fa-check-circle"></i>"IO"</span>
                    </label>
                </div>
                <div class="three-one-columns">
                    <label id="first_name" class="span-two" for="first_name">First Name</label>
                    <input name="first_name" type="text" v-model="form.form_data.section_b.first_name" ref="first_name" :disabled="sectionBComplete || capturingSignature">
                    <label class="checkbox" id="first_initial">
                        <input type="checkbox" v-model="form.form_data.section_b.first_initial" :disabled="sectionBComplete || capturingSignature">
                        <span :class="{disabled: sectionBComplete || capturingSignature}"><i class="fas fa-check-circle"></i>"IO"</span>
                    </label>
                </div>
                <div class="three-one-columns" style="grid-template-columns: 1fr 0.8fr;">
                    <label id="middle_name" class="span-two" for="middle_name">Middle Name</label>
                    <input name="middle_name" type="text" v-model="form.form_data.section_b.middle_name" :disabled="sectionBComplete || capturingSignature" @keyup="form.form_data.section_b.middle_initial = false; form.form_data.section_b.no_middle_name = false">
					<div>
	                    <label class="checkbox" id="middle_initial">
	                        <input type="checkbox" v-model="form.form_data.section_b.middle_initial" :disabled="sectionBComplete || capturingSignature || form.form_data.section_b.middle_name.length > 1">
	                        <span :class="{disabled: sectionBComplete || capturingSignature || form.form_data.section_b.middle_name.length > 1}"><i class="fas fa-check-circle"></i>"IO"</span>
	                    </label>
	                    <label class="checkbox" id="no_middle_name">
	                        <input type="checkbox" v-model="form.form_data.section_b.no_middle_name" :disabled="sectionBComplete || capturingSignature || form.form_data.section_b.middle_name.length > 0">
	                        <span :class="{disabled: sectionBComplete || capturingSignature || form.form_data.section_b.middle_name.length > 0 }"><i class="fas fa-check-circle"></i>"NMN"</span>
	                    </label>
					</div>
                </div>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(9) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(9)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(9) > -1">
                    <strong>Question 9.</strong> Transferee's/Buyers Full Name: If the transferee's/buyer's name is illegible, the transferor/seller must print the transferee's/buyer's name above the name written by the transferee/buyer.
                </div>
            </div>

            <div class="form-line">10. Current State of Residence and Address (U.S. postal abbreviations are acceptable. Cannot be a post office box.)</div>
            <div class="two-columns">
                <div class="address-1">
                    <label id="address_1">Number and Street Address</label>
                    <input type="text" v-model="form.form_data.section_b.address_1" ref="address_1" :disabled="sectionBComplete || capturingSignature">
                </div>
                <div class="city">
                    <label id="city">City</label>
                    <input type="text" v-model="form.form_data.section_b.city" ref="city" :disabled="sectionBComplete || capturingSignature">
                </div>
			</div>
            <div class="form-line three-columns address">
                <div class="state">
                    <label id="state">State</label>
                    <select v-model="form.form_data.section_b.state" ref="state" :disabled="sectionBComplete || capturingSignature">
                        <option value="">Select...</option>
                        <option v-for="(state, abbr) in this.STATES_LIST" :value="abbr">{{ state }}</option>
                        <!-- <option v-for="(state, abbr) in getEnicsStateOfResidenceCodes" :value="abbr">{{ state }}</option> -->
                    </select>
                </div>
                <div class="zip-code">
                    <label id="zip_code">Zip Code</label>
                    <input type="text" v-model="form.form_data.section_b.zip_code" ref="zip_code" :disabled="sectionBComplete || capturingSignature">
                </div>
                <div class="county">
                    <label id="county">County/Parish/Borough</label>
                    <input type="text" v-model="form.form_data.section_b.county" ref="county" :disabled="sectionBComplete || capturingSignature">
                </div>
            </div>

            <div class="form-line">
                <label class="checkbox with-outside-label">
					<input :disabled="sectionBComplete || capturingSignature" type="checkbox" id="nics_buyer_background_check" v-model="extraAddress">
					<span><i class="fas fa-check-circle"></i></span>
                    <span class="label-text">Are you a service member who is acquiring a firearm in a State where your permanent duty station is located, but reside in a different State?</span>
				</label>
            </div>

            <template v-if="extraAddress">
                <div class="form-line">Home State and Address (U.S.Postal abbreviations are acceptable. Cannot be a post office box.)</div>
                <div class="form-line five-columns address">
                    <div class="home-address-1">
                        <label id="home_address_1">Number and Street Address</label>
                        <input type="text" v-model="form.form_data.section_b.home_address_1" ref="address_1" :disabled="sectionBComplete || capturingSignature">
                    </div>
                    <div class="home-city">
                        <label id="home_city">City</label>
                        <input type="text" v-model="form.form_data.section_b.home_city" ref="city" :disabled="sectionBComplete || capturingSignature">
                    </div>
                    <div class="home-state">
                        <label id="home_state">State</label>
                        <select v-model="form.form_data.section_b.home_state" ref="state" :disabled="sectionBComplete || capturingSignature">
                            <option :value="null">State...</option>
                            <option v-for="(state, abbr) in this.STATES_LIST" :value="abbr">{{ state }}</option>
                        </select>
                    </div>
                    <div class="home-zip-code">
                        <label id="home_zip_code">Zip Code</label>
                        <input type="text" v-model="form.form_data.section_b.home_zip_code" ref="zip_code" :disabled="sectionBComplete || capturingSignature">
                    </div>
                    <div class="home-county">
                        <label id="home_county">County/Parish/Borough</label>
                        <input type="text" v-model="form.form_data.section_b.home_county" ref="county" :disabled="sectionBComplete || capturingSignature">
                    </div>
                </div>
            </template>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(10) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(10)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(10) > -1">
                    <p><strong>Question 10.</strong> Current Residence Address: A rural route (RR) may be accepted provided the transferee/buyer lives in a State or locality where it is considered a legal residence address.</p>
                    <p>If the transferee/buyer is a member of the Armed Forces on active duty, his/her State of residence is the State in which his/her permanent duty station is located. If the service member is acquiring a firearm in a State where his/her permanent duty station is located, but resides in a different State, the transferee/buyer must list both his/her permanent duty station address and residence address. If the transferee/buyer has two States of residence, the transferee/buyer should list his/her current residence address (e.g., if the transferee/buyer is purchasing a firearm while staying at his/her weekend home in State X, list the address in State X).</p>
                </div>
            </div>

            <div id="place_of_birth" class="form-line">11. Place of Birth</div>
            <div class="form-line four-columns place-of-birth">
				<label id="birth_city">U.S. City
    				<input type="text" v-model="form.form_data.section_b.birth_city" ref="birth_city" :disabled="sectionBComplete || capturingSignature">
				</label>
                <label id="place_of_birth_state" for="pob_code">State
                    <select name="pob_code" v-model="form.form_data.section_b.pob_code" ref="pob_code" :disabled="sectionBComplete || capturingSignature">
    				    <option :value="null">State...</option>
    				    <option v-for="(state, abbr) in this.STATES_LIST" :value="abbr">{{ state }}</option>
    				</select>
                </label>
                <span>- OR -</span>
                <label id="foreign_country">Foreign Country
    				<select v-model="form.form_data.section_b.foreign_country" ref="foreign_country" :disabled="sectionBComplete || capturingSignature">
    				    <option :value="null">Country...</option>
    				    <option v-for="(country, code) in this.COUNTRIES_LIST" :value="country">{{ country }}</option>
    				</select>
                </label>
            </div>
            <div class="form-line three-columns align-items-start height-weight-sex">
                <div class="height">
                    <div class="span-two">12. Height</div>
                    <label id="feet">Ft.</label>
                    <input type="number" v-model="form.form_data.section_b.feet" ref="feet" :disabled="sectionBComplete || capturingSignature">
                    <label id="inches">In.</label>
                    <input type="number" v-model="form.form_data.section_b.inches" ref="inches" :disabled="sectionBComplete || capturingSignature">
                </div>
                <div class="weight">
                    <label id="weight" for="weight">13. Weight (lbs)</label>
                    <input type="number" v-model="form.form_data.section_b.weight" ref="weight" :disabled="sectionBComplete || capturingSignature">
                </div>
                <div class="sex">
                    <label id="sex" style="padding-bottom: 0.5em;">14. Sex</label>
                    <label class="radio first">
    					<input type="radio" v-model="form.form_data.section_b.gender_code" value="M" :disabled="sectionBComplete || capturingSignature">
    					<span :class="{disabled: sectionBComplete || capturingSignature}"><i class="fas fa-check-circle"></i>Male</span>
    				</label>
    				<label class="radio">
    					<input type="radio" v-model="form.form_data.section_b.gender_code" value="F" :disabled="sectionBComplete || capturingSignature">
    					<span :class="{disabled: sectionBComplete || capturingSignature}"><i class="fas fa-check-circle"></i>Female</span>
    				</label>
                    <label class="radio last">
    					<input type="radio" v-model="form.form_data.section_b.gender_code" value="U" :disabled="sectionBComplete || capturingSignature">
    					<span :class="{disabled: sectionBComplete || capturingSignature}"><i class="fas fa-check-circle"></i>Non-Binary</span>
    				</label>
                </div>
                <div class="help-box-outer form-full">
                    <div :class="['help-box-label', showHelp.indexOf(14) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(14)"><i class="fas fa-info"></i></div>
                    <div class="help-box"  v-show="showHelp.indexOf(14) > -1">
                        Question 14. Sex: Individuals with neither male nor female on their identification document(s) should check Non-Binary.
                    </div>
                </div>
            </div>
            <div id="birthdate" class="form-line">15. Birth Date</div>
            <div class="form-line two-columns">
                <date-input :class="{ error: signedDateError }" v-model="form.form_data.section_b.birthdate" :disabled="sectionBComplete || capturingSignature"></date-input>
            </div>

            <div class="two-columns">
            	<div class="form-line">
                	<div>16. Social Security Number (optional, but will help prevent misidentification)</div>
                	<input type="text" v-model="form.form_data.section_b.ssn" :disabled="sectionBComplete || capturingSignature">
				</div>
				<div class="form-line">
                	<div>17. Unique Personal Identification Number (UPIN) or Appeals Management Database Identification (AMD ID) (if applicable)</div>
                	<input type="text" v-model="form.form_data.section_b.upin" :disabled="sectionBComplete || capturingSignature">
				</div>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(17) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(17)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(17) > -1">
                    Question 17. Unique Personal Identification Number (UPIN) or Appeals Management Database Identification (AMD ID): For transferees/buyers approved to have information maintained about them in the FBI NICS Voluntary Appeal File, NICS will provide them with a UPIN, which the transferee/buyer should record in question 17. The AMD ID is a number that will be provided to an appellant on certain types of overturned appeals and should also be recorded in question 17. The transferor/seller should provide the UPIN/AMD ID when conducting background checks through the NICS or the State POC.
                </div>
            </div>

            <div class="form-line two-columns" style="grid-template-columns: 1fr 4fr;">
                <div class="ethnicity">
    				<div id="ethnicity">18.a. Ethnicity</div>
    				<label>Hispanic or Latino</label>
    				<div class="control-group">
    					<label class="radio first">
    						<input type="radio" v-model="form.form_data.section_b.ethnicity" value="hispanic" :disabled="sectionBComplete || capturingSignature">
    						<span :class="{disabled: sectionBComplete || capturingSignature}"><i class="fas fa-check-circle"></i>Yes</span>
    					</label>
    					<label class="radio last">
    						<input type="radio" v-model="form.form_data.section_b.ethnicity" value="nonhispanic" :disabled="sectionBComplete || capturingSignature">
    						<span :class="{disabled: sectionBComplete || capturingSignature}"><i class="fas fa-check-circle"></i>No</span>
    					</label>
    				</div>
    			</div>

    			<div class="race">
    				<div id="customer_race">18.b. Race</div>
					<label>(Select one or more race in 18.b. Both 18.a. and 18.b. must be answered.)</label>
    				<div id="race">
    					<label class="checkbox">
    						<input type="checkbox" v-model="form.form_data.section_b.customer_race.l4" :disabled="sectionBComplete || capturingSignature">
    						<span :class="{disabled: sectionBComplete || capturingSignature}"><i class="fas fa-check-circle"></i>American Indian or Alaskan Native</span>
    					</label>

    					<label class="checkbox">
    						<input type="checkbox" v-model="form.form_data.section_b.customer_race.l2" :disabled="sectionBComplete || capturingSignature">
    						<span :class="{disabled: sectionBComplete || capturingSignature}"><i class="fas fa-check-circle"></i>Black or African American</span>
    					</label>

    					<label class="checkbox">
    						<input type="checkbox" v-model="form.form_data.section_b.customer_race.l6" :disabled="sectionBComplete || capturingSignature">
    						<span :class="{disabled: sectionBComplete || capturingSignature}"><i class="fas fa-check-circle"></i>White</span>
    					</label>

    					<label class="checkbox">
    						<input type="checkbox" v-model="form.form_data.section_b.customer_race.l1" :disabled="sectionBComplete || capturingSignature">
    						<span :class="{disabled: sectionBComplete || capturingSignature}"><i class="fas fa-check-circle"></i>Asian</span>
    					</label>

    					<label class="checkbox">
    						<input type="checkbox" v-model="form.form_data.section_b.customer_race.l5" :disabled="sectionBComplete || capturingSignature">
    						<span :class="{disabled: sectionBComplete || capturingSignature}"><i class="fas fa-check-circle"></i>Native Hawaiian or Other Pacific Islander</span>
    					</label>
    				</div>
    			</div>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(18) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(18)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(18) > -1">
                    <p>Questions 18.a. and 18.b. Ethnicity and Race: Federal regulations (27 CFR 478.124(c)(1)) require licensees to obtain the race of the transferee/buyer. This information helps the FBI and/or State POC make or rule out potential matches during the background check process and can assist with criminal investigations.</p>

                    <p>Ethnicity refers to a person's heritage. Persons of Cuban, Mexican, Puerto Rican, South or Central American, or other Spanish culture or origin, regardless of race, are considered Hispanic or Latino.</p>

                    <p>Race - one or more of the following responses must be selected: (1) American Indian or Alaska Native - A person having origins in any of the original peoples of North and South America (including Central America), and who maintains a tribal affiliation or community attachment; (2) Asian - A person having origins in any of the original peoples of the Far East, Southeast Asia, or the Indian subcontinent including, for example, Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand, and Vietnam; (3) Black or African American - A person having origins in any of the Black racial groups of Africa; (4) Native Hawaiian or Other Pacific Islander - A person having origins in any of the original peoples of Hawaii, Guam, Samoa, or other Pacific Islands; and/or (5) White - A person having origins in any of the original peoples of Europe, the Middle East, or North Africa. Select the closest representation for any other race or ethnicity that does not fall within those indicated.</p>
                </div>
            </div>
            <div id="citizen_status_code" class="form-line">19. Country of Citizenship: (Check/List more than one, if applicable. Nationals of the United States may check U.S.A.)</div>
            <div class="form-line" id="origin_country">
                <label class="usa-label radio first">
                    <input type="radio" v-model="form.form_data.section_b.citizen_status_code" value="C" id="usa" :disabled="sectionBComplete">
                    <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>United States of America (U.S.A.)</span>
                </label>
                <label class="other-label radio last">
                    <input type="radio" v-model="form.form_data.section_b.citizen_status_code" value="F" id="other" :disabled="sectionBComplete">
                    <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Other Country/Countries (Specify):</span>
                </label>
                <div v-if="form.form_data.section_b.citizen_status_code == 'F'" class="three-columns">
                    <select v-model="form.form_data.section_b.citizen_country_code" :disabled="sectionBComplete">
                        <option value>Country...</option>
                        <option v-for="(country, code) in this.COUNTRIES_LIST" :value="code">{{ country }}</option>
                    </select>
                    <select v-model="form.form_data.section_b.citizen_country_code_2" v-if="form.form_data.section_b.citizen_country_code" :disabled="sectionBComplete">
                        <option value>Country...</option>
                        <option v-for="(country, code) in this.COUNTRIES_LIST" :value="code">{{ country }}</option>
                    </select>
                    <select v-model="form.form_data.section_b.citizen_country_code_3" v-if="form.form_data.section_b.citizen_country_code && form.form_data.section_b.citizen_country_code_2" :disabled="sectionBComplete">
                        <option value>Country...</option>
                        <option v-for="(country, code) in this.COUNTRIES_LIST" :value="code">{{ country }}</option>
                    </select>
                </div>
            </div>
            <div class="form-line three-columns">
                <div id="mnu1" for="mnu1">20. If you are an alien, record your U.S.-issued alien or admission number (AR#, USCIS#, or I94#)</div>
                <input type="text" v-model="form.form_data.section_b.mnu1" :disabled="sectionBComplete || capturingSignature">
				<select id="mnu_type_code1" v-if="form.form_data.section_b.mnu1" v-model="form.form_data.section_b.mnu_type_code1" style="width: 7em;" :disabled="sectionBComplete || capturingSignature">
					<option value="">Select...</option>
					<option value="AR">Alien Registration Number or USCIS</option>
					<option value="I9">Non-Immigrant Admissions Number</option>
				</select>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(20) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(20)"><i class="fas fa-info"></i></div>
                <div class="help-box"  v-show="showHelp.indexOf(20) > -1">
                    Question 20. U.S.-issued Alien Number or Admission Number: U.S.-issued alien and admission numbers may be found on the following U.S. Department of Homeland Security documents: Legal Resident Card or Employment Authorization Card (AR# or USCIS#); Arrival/Departure Record, Form I94, or Form 797A (I94#). Additional information can be obtained from www.cbp.gov. If you are a U.S. citizen or U.S. national, the response to this question should be left blank.
                </div>
            </div>

            <div class="form-line">21. Answer the following questions by checking or marking either the “yes” or “no” box to the right of the questions</div>
            <div class="form-line three-one-columns">
                <label id="actual_buyer" for="actual_buyer" class="small">a. Are you the actual transferee/buyer of the firearm(s) listed on this form and any continuation sheet(s) (ATF Form 5300.9A)? Warning: You are not the actual transferee/buyer if you are acquiring the firearm(s) on behalf of another person. If you are not the actual transferee/buyer, the licensee cannot transfer the firearm(s) to you. Exception: If you are only picking up a repaired firearm(s) for another person, you are not required to answer 21.a. and may proceed to question 21.b.</label>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.actual_buyer" value="yes" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.actual_buyer" value="no" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('21.a.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('21.a.')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('21.a.') > -1">
                    <p>Question 21.a. Actual Transferee/Buyer: For purposes of this form, a person is the actual transferee/buyer if he/she is purchasing the firearm for him/herself or otherwise acquiring the firearm for him/herself. (e.g., redeeming the firearm from pawn, retrieving it from consignment, firearm raffle winner). A person is also the actual transferee/buyer if he/she is legitimately purchasing the firearm as a bona fide gift for a third party. A gift is not bona fide if another person offered or gave the person completing this form money, service(s), or item(s) of value to acquire the firearm for him/her, or if the other person is prohibited by law from receiving or possessing the firearm.</p>

                    <p>EXAMPLES: Mr. Smith asks Mr. Jones to purchase a firearm for Mr. Smith (who may or may not be prohibited). Mr. Smith gives Mr. Jones the money for the firearm. Mr. Jones is NOT THE ACTUAL TRANSFEREE/BUYER of the firearm and must answer "no" to question 21.a. The licensee may not transfer the firearm to Mr. Jones. However, if Mr. Brown buys the firearm with his own money to give to Mr. Black as a gift (with no service or tangible thing of value provided by Mr. Black), Mr. Brown is the actual transferee/buyer of the firearm and should answer "yes" to question 21.a. However, the transferor/seller may not transfer a firearm to any person he/she knows or has reasonable cause to believe is prohibited under 18 U.S.C. 922(g), (h), (n), or (x).</p>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <label id="under_indictment" for="under_indictment" class="small">b. Are you under indictment or information in any court for a felony, or any other crime for which the judge could imprison you for more than one year, or are you a current member of the military who has been charged with violation(s) of the Uniform Code of Military Justice and whose charge(s) have been referred to a general court-martial?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.under_indictment" value="yes" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.under_indictment" value="no" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>
            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('21.b.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('21.b.')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('21.b.') > -1">
                    <p>Questions 21.b. - 21.l. Prohibited Persons: Generally, 18 U.S.C. 922(g) prohibits the shipment, transportation, receipt, or possession in or affecting interstate commerce of a firearm by one who: has been convicted of a felony in any Federal, including a general court-martial, State or local court, or any other crime, punishable by imprisonment for a term exceeding one year; is a fugitive from justice; is an unlawful user of, or addicted to, marijuana or any depressant, stimulant, or narcotic drug, or any other controlled substance; has been adjudicated as a mental defective or has been committed to a mental institution; has been discharged from the Armed Forces under dishonorable conditions; is subject to certain restraining orders; convicted of a misdemeanor crime of domestic violence under Federal, including a general court-martial, State or Tribal law; has renounced his/her U.S. citizenship; is an alien illegally in the United States or an alien admitted to the United States under a nonimmigrant visa. Furthermore, section 922(n) prohibits the shipment, transportation, or receipt in or affecting interstate commerce of a firearm by one who is under indictment or information for a felony in any Federal, including a general court-martial, State or local court, or any other crime, punishable by imprisonment for a term exceeding one year. An information is a formal accusation of a crime verified by a prosecutor.</p>
                    <p>A member of the Armed Forces must answer "yes" to 21.b. if charged with an offense that is referred to a general court-martial. A current or former member of the Armed Forces must answer "yes" to 21.c. if convicted under a general court-martial.</p>
                    <p>Discharged "under dishonorable conditions" means separation from the Armed Forces resulting from a dishonorable discharge or dismissal adjudged by a general court-martial. That term does not include any other discharge or separation.</p>
                    <p>EXCEPTION: A person is not prohibited from receiving or possessing a firearm
                    if that person: (1) has been convicted of any Federal or State offense pertaining to antitrust violations, unfair trade practices, restraints of trade, or other similar offenses relating to the regulation of business practices; (2) has been convicted of a State misdemeanor punishable by imprisonment of two years or less; or (3) following conviction of a felony or other crime for which the judge could have imprisoned the person for more than one year, or a misdemeanor crime of domestic violence, has received a pardon, an expungement or set aside of the conviction, or has lost and regained civil rights (the right to vote, sit on a jury, and hold public office) in the jurisdiction in which the conviction occurred, AND the law of the convicting jurisdiction does not prohibit the person from receiving or possessing firearms. Person subject to any of these exceptions, or who received relief from disabilities under 18 U.S.C. 925(c), should answer "no" to the applicable question.</p>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <label id="convict" for="convict" class="small">c. Have you ever been convicted in any court, including a military court, of a felony, or any other crime for which the judge could have imprisoned you for more than one year, even if you received a shorter sentence including probation?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.convict" value="yes" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.convict" value="no" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <label id="fugitive" for="fugitive" class="small">d. Are you a fugitive from justice?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.fugitive" value="yes" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.fugitive" value="no" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>
            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('21.d.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('21.d.')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('21.d.') > -1">
                    <p>Question 21.d. Fugitive from Justice: Any person who has fled from any State to avoid prosecution for a felony or a misdemeanor; or any person who leaves the State to avoid giving testimony in any criminal proceeding. The term also includes any person who knows that misdemeanor or felony charges are pending against such person and who leaves the State of prosecution.</p>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <label id="addict" for="addict" class="small">e. Are you an unlawful user of, or addicted to, marijuana or any depressant, stimulant, narcotic drug, or any other controlled substance? <strong>Warning:</strong> The use or possession of marijuana remains unlawful under Federal law regardless of whether it has been legalized or decriminalized  for medicinal or recreational purposes in the state where you reside.</label>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.addict" value="yes" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.addict" value="no" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <label id="mental" for="mental" class="small">f. Have you ever been adjudicated as a mental defective OR have you ever been committed to a mental institution?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.mental" value="yes" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.mental" value="no" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>
            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf(8) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(8)"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf(8) > -1">
                    <p>Question 21.f. Adjudicated as a Mental Defective: A determination by a court, board, commission, or other lawful authority that a person, as a result of marked subnormal intelligence, or mental illness, incompetency, condition, or disease: (1) is a danger to himself or to others; or (2) lacks the mental capacity to contract or manage his own affairs. This term shall include: (1) a finding of insanity by a court in a criminal case; and (2) those persons found incompetent to stand trial or found not guilty by reason of lack of mental responsibility.</p>
                    <p>Committed to a Mental Institution: A formal commitment of a person to a mental institution by a court, board, commission, or other lawful authority. The term includes a commitment to a mental institution involuntarily. The term includes commitment for mental defectiveness or mental illness. It also includes commitments for other reasons, such as for drug use. The term does not include a person in a mental institution for observation or a voluntary admission to a mental institution.</p>
                    <p>EXCEPTION: Under the NICS Improvement Amendments Act of 2007, a person who has been adjudicated as a mental defective or committed to a mental institution in a State proceeding is not prohibited by the adjudication or commitment if the person has been granted relief by the adjudicating/committing State pursuant to a qualifying mental health relief from disabilities program. Also, a person who has been adjudicated as a mental defective or committed to a mental institution by a department or agency of Federal Government is not prohibited by the adjudication or commitment if either: (a) the person's adjudication or commitment was set aside or expunged by the adjudicating/committing agency; (b) the person has been fully released or discharged from all mandatory treatment, supervision, or monitoring by the agency; (c) the person was found by the agency to no longer suffer from the mental health condition that served as the basis of the initial adjudication/commitment; (d) the adjudication or commitment, respectively, is based solely on a medical finding of disability, without an opportunity for a hearing by a court, board, commission, or other lawful authority, and the person has not been adjudicated as a mental defective consistent with section 922(g)(4) of title 18, United States Code; or (e) the person was granted relief from the adjudicating/committing agency pursuant to a qualified mental health relief from disabilities program. This exception to an adjudication or commitment by a Federal department or agency does not apply to any person who was adjudicated to be not guilty by reason of insanity, or based on lack of mental responsibility, or found incompetent to stand trial, in any criminal case or under the Uniform Code of Military Justice. Persons who fall within one of the above exceptions should answer "no" to question 21.f.</p>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <label id="dishonorable_discharge" for="dishonorable_discharge" class="small">g. Have you ever been discharged from the Armed Forces under dishonorable conditions?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.dishonorable_discharge" value="yes" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.dishonorable_discharge" value="no" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <label id="restraining_order" for="restraining_order" class="small">h. Are you subject to a court order, including a Military Protection Order issued by a military judge or magistrate, restraining you from harassing, stalking, or threatening your child or an intimate partner or child of such partner?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.restraining_order" value="yes" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.restraining_order" value="no" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>
            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('21.h.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('21.h.')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('21.h.') > -1">
                    <p>Question 21.h. Qualifying Restraining Orders: Under 18 U.S.C. 922, firearms may not be sold to or received by persons subject to a court order that: (A) was issued after a hearing which the person received actual notice of and had an opportunity to participate in; (B) restrains such person from harassing, stalking, or threatening an intimate partner or child of such intimate partner or person, or engaging in other conduct that would place an intimate partner in reasonable fear of bodily injury to the partner or child; and (C)(i) includes a finding that such person represents a credible threat to the physical safety of such intimate partner or child; or (ii) by its terms explicitly prohibits the use, attempted use, or threatened use of physical force against such intimate partner or child that would reasonably be expected to cause bodily injury. An "intimate partner" of a person is: the spouse or former spouse of the person, the parent of a child of the person, or an individual who cohabitates or has cohabitated with the person.</p>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <label id="domestic_violence" for="domestic_violence" class="small">i. Have you ever been convicted in any court of a misdemeanor crime of domestic violence, or are you or have you ever been a member of the military and been convicted of a crime that included, as an element, the use of force against a person as identified in the instructions?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.domestic_violence" value="yes" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.domestic_violence" value="no" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('21.i.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('21.i.')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('21.i.') > -1">
                    <p>Question 21.i. Misdemeanor Crime of Domestic Violence: A Federal, including a general court-martial, State, local, or tribal offense that is a misdemeanor under Federal, State, or tribal law and has, as an element, the use or attempted use of physical force, or the threatened use of a deadly weapon, committed by a current or former spouse, parent, or guardian of the victim, by a person with whom the victim shares a child in common, by a person who is cohabitating with, or has cohabited with the victim as a spouse, parent, or guardian, or by a person similarly situated toa spouse, parent, or guardian of the victim. The term includes all misdemeanors that have as an element the use or attempted use of physical force or the threatened use of a deadly weapon (e.g., assault and battery), if the offense is committed by one of the defined parties. (See Exception to 21.b. - 21.l.) A person who has been convicted of a misdemeanor crime of domestic violence also is not prohibited unless: (1) the person was represented by a lawyer or gave up the right to a lawyer; or (2) if the person was entitled to a jury, was tried by a jury, or gave up the right to a jury trial. Persons subject to this exception should answer "no" to 21.i.</p>

                    <p>A current or former member of the military who has been convicted of a violation of the Uniform Code of Military Justice that included, as an element, the use of force against a person as identified in the instructions under question 21.i. must answer "yes" to this question. This may include a qualifying offense that was referred to a special or general court-martial.</p>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <label id="renounced_citizenship" for="renounced_citizenship" class="small">j. Have you ever renounced your United States citizenship?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.renounced_citizenship" value="yes" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.renounced_citizenship" value="no" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <label id="illegal_alien" for="illegal_alien" class="small">k. Are you an alien <strong>illegally</strong> or <strong>unlawfully</strong> in the United States?</label>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.illegal_alien" value="yes" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.illegal_alien" value="no" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <div id="legal_alien" for="legal_alien">21.l.1. Are you an alien who has been admitted to the United States under a nonimmigrant visa?</div>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.legal_alien" value="yes" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.legal_alien" value="no" :disabled="sectionBComplete">
                        <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <div id="exc_code" for="exc_code">21.l.2. If you are such an alien do you fall within any of the exceptions stated in the instructions? <br><b>(U.S. citizens/nationals leave 21.l.2. blank)</b></div>
                <div class="control-group">
                    <label class="radio first">
                        <input type="radio" v-model="form.form_data.section_b.exc_code" value="yes" :disabled="sectionBComplete || isCitizen">
                        <span :class="{ disabled: sectionBComplete || isCitizen }"><i class="fas fa-check-circle"></i>Yes</span>
                    </label>
                    <label class="radio last">
                        <input type="radio" v-model="form.form_data.section_b.exc_code" value="no" :disabled="sectionBComplete || isCitizen">
                        <span :class="{ disabled: sectionBComplete || isCitizen }"><i class="fas fa-check-circle"></i>No</span>
                    </label>
                </div>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('21.l.') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('21.l.')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('21.l.') > -1">
                    <p>Question 21.l. Immigration Status: An alien admitted to the United States under
                    a nonimmigrant visa includes, among others, persons visiting the United States temporarily for business or pleasure, persons studying in the United States who maintain a residence abroad, and certain temporary foreign workers. These aliens must answer "yes" to this question and provide the additional documentation as required under question 26.d.to establish they are excepted from the nonimmigrant alien prohibition. Permanent resident aliens and aliens legally admitted to the United States pursuant to either the Visa Waiver Program or to regulations otherwise exempting them from visa requirements may answer "no" to this question, leave 21.l.2 blank and are not required to submit the additional documentation under question 26.d.</p>
                </div>
            </div>

            <div class="form-line three-one-columns">
                <strong id="i_certify">I certify that my answers in Section B are true, correct, and complete. I have read and understand the Notices, Instructions, and Definitions on ATF Form 4473. I understand that answering “yes” to question 21.a. if I am not the actual transferee/buyer is a crime punishable as a felony under Federal law, and may also violate State and/or local law. I understand that a person who answers “yes” to any of the questions 21.b. through 21.k. is prohibited from receiving or possessing a firearm. I understand that a person who answers “yes” to question 21.l.1. is prohibited from receiving or possessing a firearm, unless the person answers “yes” to question 21.l.2. and provides the documentation required in 26.d. I also understand that making any false oral or written statement, or exhibiting any false or misrepresented identification with respect to this transaction, is a crime punishable as a felony under Federal law, and may also violate State and/or local law. I further understand that the repetitive purchase of firearms for the purpose of resale for livelihood and profit without a Federal firearms license is a violation of Federal law.</strong>
                <label class="checkbox" id="i_certify">
                    <input type="checkbox" v-model="form.form_data.section_b.i_certify" :disabled="sectionBComplete">
                    <span :class="{disabled: sectionBComplete}"><i class="fas fa-check-circle"></i></span>
                </label>
            </div>

            <div class="form-line three-one-columns">
                <div>
                    <div id="signature">22. Transferee’s/Buyer’s Signature</div>
					<!-- display signature if it's been saved and if not currently capturing -->
                    <div class="signature-group" v-if="form.form_data && form.form_data.section_b.signature && !capturingSignature">
                        <img class="signature" :src="form.form_data.section_b.signature" alt="" style="border: 1px solid #ccc;">
                        <div v-if="!sectionBComplete" class="cancel-signature" @click="captureBuyersSignature()"><i class="fas fa-times"></i></div>
                    </div>
					<!-- display signature canvas if capturingSignature -->
                    <div class="signature-group" v-else-if="capturingSignature">
                        <canvas id="buyers_signature_pad" :width="signaturePadOnScreen ? 600 : 330" :height="signaturePadOnScreen ? 213 : 100"></canvas>
						<!-- show the clearCanvas control if signatureSaved -->
                        <div v-if="signatureSaved" class="cancel-signature" @click="clearCanvas()"><i class="fas fa-times"></i></div>
						<!-- otherwise show the stop-capturing signature control -->
                        <div v-else class="cancel-signature" @click="capturingSignature = false"><i class="fas fa-times"></i></div>
						<!-- regardless of on-screen or signature pad, show accept and clear controls -->
						<div class="controls">
							<div class="button action spaced" @click="saveSignature()">Accept</div>
							<div class="button warning spaced" @click="clearCanvas()">Clear</div>
						</div>
                    </div>
                    <div class="signature" v-else>
                        <button v-if="!sectionBComplete" class="primary button" @click="captureBuyersSignature()">Connect To Signature Pad</button>
                        <button v-if="enableSignOnScreen && !sectionBComplete" class="primary button" style="margin: 0 0 0 1em;" @click="captureBuyersSignature(true)">Sign on Screen</button>
                    </div>
                </div>
                <div>
                    <div id="signed_date">23. Date</div>
                    <date-input disabled="true" :class="{ error: signedDateError }" v-model="form.form_data.section_b.signed_date"></date-input>
                </div>
            </div>

            <div class="help-box-outer form-full">
                <div :class="['help-box-label', showHelp.indexOf('22') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('22')"><i class="fas fa-info"></i></div>
                <div class="help-box" v-show="showHelp.indexOf('22') > -1">
                    <p>Question 22. Transferee/Buyer Certification: Under 18 U.S.C. 922(a)(1), it is unlawful for a person to engage in the business of dealing in firearms without a license. A person is engaged in the business of dealing in firearms if he/she devotes time, attention, and labor to dealing in firearms as a regular course of trade or business with the principal objective of livelihood and profit through the repetitive purchase and resale of firearms. A license is not required of a person who only makes occasional sales, exchanges, or purchases of firearms for the enhancement of a personal collection or for a hobby, or who sells all or part of his/her personal collection of firearms.</p>
                </div>
            </div>

			<template v-if="sectionBComplete">
				<h2 class="form-full section-title">Section D - Must Be Completed Personally By Transferee/Buyer</h2>
				<div class="form-full" style="margin: 1em 0;">If the transfer of the firearm(s) takes place on a different day from the date that the transferee/buyer signed Section B, the transferee/buyer must complete Section D immediately prior to the transfer of the firearm(s).</div>
				<div class="form-full"><b>I certify that my answers to the questions in Section B of this form are still true, correct, and complete.</b></div>

	            <div class="form-line three-one-columns">
					<div>
						<div class="form-threequarter light-font">
							<div>30. Transferee's/Buyer's Signature</div>
							<div v-if="nicsDelayed" style="margin: 1em 0;">NICS Delayed response requires Section C, 27.d to be completed before signing.</div>
							<div class="signature-group" v-if="form.form_data && form.form_data.section_d.buyer_recertification_signature && !capturingSectionDSignature">
								<img class="signature" :src="form.form_data.section_d.buyer_recertification_signature">
								<div class="cancel-signature" @click="cancelSignature()"><i class="fas fa-times"></i></div>
							</div>
		                    <div class="signature-group" v-else-if="capturingSectionDSignature">
		                        <canvas id="section_d_buyers_signature_pad" :width="signaturePadOnScreen ? 600 : 330" :height="signaturePadOnScreen ? 213 : 100"></canvas>
								<!-- show the clearCanvas control if signatureSaved -->
		                        <div v-if="signatureSaved" class="cancel-signature" @click="clearCanvas()"><i class="fas fa-times"></i></div>
								<!-- otherwise show the stop-capturing signature control -->
		                        <div v-else class="cancel-signature" @click="capturingSectionDSignature = false"><i class="fas fa-times"></i></div>
								<!-- regardless of on-screen or signature pad, show accept and clear controls -->
								<div class="controls">
									<button class="button action" @click="saveSignature()">Accept</button>
									<button class="button warning" style="margin: 0 0 0 1em;" @click="clearCanvas()">Clear</button>
								</div>
		                    </div>
		                    <div class="signature" v-else>
		                        <button :class="['button', nicsDelayed ? 'disabled' : 'primary' ]" @click="captureBuyersSignature()">Connect To Signature Pad</button>
								<button v-if="enableSignOnScreen" :class="['button', nicsDelayed ? 'disabled' : 'primary' ]" style="margin: 0 0 0 1em;" @click="captureBuyersSignature(true)">Sign on Screen</button>
		                    </div>
						</div>
					</div>
					<div class="form-quarter light-font signature">
						<div>31. Recertification Date</div>
                    	<date-input v-if="formOption == 'existing'" :class="{ error: buyerRecertificationDateError }" v-model="form.form_data.section_d.buyer_recertification_date" :disabled="!form.internal_use_only"></date-input>
						<input class="disabled" disabled type="date" v-model="form.form_data.section_d.buyer_recertification_date" v-else>
						<div class="tooltip" v-if="buyerRecertificationDateError">Please select today's date</div>
					</div>
				</div>

				<div class="help-box-outer form-full">
					<div :class="['help-box-label', showHelp.indexOf('30') > -1 ? 'help-box-label-live' : '']" @click="toggleHelp('30')"><i class="fas fa-info"></i></div>
					<div class="help-box" v-show="showHelp.indexOf('30') > -1">
						Questions 30 and 31. Transfer on a Different Day and Recertification: If the transfer takes place on a different day from the date that the transferee/buyer signed Section B, the licensee must again check the photo identification of the transferee/ buyer at the time of transfer.
					</div>
				</div>
			</template>

            <div class="user-initials" v-if="form.internal_use_only">
				<div>
                	<label>User initials</label><input type="text" v-model="userInitials">
				</div>
                <div v-if="userInitials.length < 2">Your initials are required to correct the form.</div>
            </div>
			<div v-if="form.internal_use_only == 1" style="padding: 0 0 5em 0;">
				<button v-if="!sectionBComplete" :class="['button', 'action', 'submit-form', { disabled: !form.form_data.section_b.signature } ]" @click.stop="moveForm()">Change Section B</button>
				<button v-else :class="['button', 'action', 'submit-form', { disabled: !userInitials } ]" @click.stop="moveForm()">Change Section D</button>
				<button class="button cancel" style="margin: 0 0 0 1em;" @click.stop="cancelMoveForm()">Cancel Change</button>
			</div>
			<div v-else style="padding: 0 0 5em 0;">
				<button v-if="!sectionBComplete" :class="['button', 'action', 'submit-form', { disabled: !form.form_data.section_b.signature } ]" @click.stop="sendForm()">Submit Section B</button>
				<button v-else :class="['button', nicsDelayed ? 'disabled' : 'action', 'submit-form' ]" @click.stop="sendForm()">Submit Section D</button>
				<span class="loading" v-if="loading"><i class="fas fa-spinner fa-spin"></i></span>
				<span class="message" style="padding: 0 0 0 1em;" v-if="message">{{ message }}</span>
			</div>
		</div>

		<div style="font-size: 0.8em; margin: 1em 0; padding: 0.5em 0; border-top: 1px solid #ccc; text-align: center;">
			<button class="button neutral" @click="resetForm()">Cancel and Log Out</button>
		</div>

	</div><!-- v-if="formIncomplete" -->

	<div class="form-complete" v-else v-cloak>
		<h1>Your completed 4473 has been saved!</h1>
		<button class="button action" @click="resetForm()">OK</button>
	</div>
</div>

</template>

<script>
import SignaturePad from 'signature_pad'
import DateInput from '@/components/DateInput'
import { mapState, mapActions } from 'vuex'
export default {
	name: 'customer-form-4473',
    components: {
        'date-input': DateInput
    },
	data() {
		return {
			apiEndpoint: '',
			logoSrc: '',
			printing: false,
			username: '',
    		password: '',
			message: 'Please have a manager log in.',
    		loading: false,
    		formId: null,
    		order_number: null,
    		sectionAForms: [],
    		search_section_a_text: null,
    		searchMessageSectionA: null,
    		sectionCForms: [],
    		search_section_c_text: null,
    		searchMessageSectionC: null,
    		formOption: null,
    		extraAddress: false,
			user: {
				user_id: '',
				user_name: '',
				user_type_code: ''
			},
            userInitials: '',
			client: {
				company_name: null,
			},
			client_logo_src: null,
            form: {
                form_number: '',
                nics_number: '',
                form_data: {
                    section_a: {
                        firearms_list: [
                            {
                                caliber: "",
                                ffl_log_book_entry_id: "",
                                gun_type: "",
                                manufacturer: "",
                                model: "",
                                serial_number: ""
                            }
                        ],
                        total_firearms_transferred: '',
                        transaction_pawn_redemption: '',
                        transaction_pawn_redemption_line_numbers: '',
                        private_party_transfer: ''
                    },
                    section_b: {
                        actual_buyer: '',
                        addict: '',
                        address_1: '',
                        birth_city: '',
                        birthdate: '',
                        citizen_country_code: '',
                        citizen_country_code_2: '',
                        citizen_country_code_3: '',
                        citizen_status_code: '',
                        city: '',
                        convict: '',
                        county: '',
                        customer_race: {l4: '', l2: '', l6: '', l1: '', l5: ''},
                        dishonorable_discharge: '',
                        domestic_violence: '',
                        ethnicity: '',
                        exc_code: '',
                        feet: '',
                        first_initial: '',
                        first_name: '',
                        foreign_country: '',
                        fugitive: '',
                        gender_code: '',
                        home_address_1: '',
                        home_city: '',
                        home_county: '',
                        home_state: '',
                        home_zip_code: '',
                        i_certify: '',
                        illegal_alien: '',
                        inches: '',
                        last_initial: '',
                        last_name: '',
                        legal_alien: '',
                        mental: '',
                        middle_initial: '',
                        middle_name: '',
                        mnu1: '',
						mnu_type_code1: '',
                        no_middle_name: '',
                        pob_code: '',
                        renounced_citizenship: '',
                        restraining_order: '',
                        signature: '',
                        signed_date: '',
                        ssn: '',
                        state: '',
						suffix: '',
                        under_indictment: '',
                        upin: '',
                        weight: '',
                        zip_code: ''
                    },
                    section_d: {
                        buyer_recertification_signature: '',
                        buyer_recertification_date: ''
                    }
                }
            },
			contact_data: {},
			signaturePadOnScreen: false,
			signaturePad: null,
			scriptel: null,
			activatingSignaturePad: false,
			birthdate: null,
			signed_date: null,
			signedDateError: false,
			buyerRecertificationDateError: false,
			showHelp: [],
			states: this.STATES_LIST,
			countries: this.COUNTRIES_LIST,
            formIncomplete: true,
			capturingSignature: false,
			capturingSectionDSignature: false,
			signatureSaved: false,
			gettingCorrectPendingForms: false,
			searchMessageCorrectPending: 'Searching...',
			correctPendingForms: [],
			enableSignOnScreen: false,
			clientHasVariance: false
		}
	},
	mounted() {
        // include scriptel library
		let scriptelScript = document.createElement('script')
		scriptelScript.setAttribute('id', 'scriptel_script')
		scriptelScript.setAttribute('src', '/dashboard/js/scriptel-easyscript.js')

		document.head.appendChild(scriptelScript)
		this.apiCallLocal('get_item_preference', { preference_type: 'system', preference_code: 'ENICS_CADENCE_CODES,ENICS_STATE_OF_RESIDENCE_CODES,ENABLE_SCREEN_CAPTURE_SIGNATURE,STORE_LOGO' }).then(obj => {
			if (obj.ENICS_CADENCE_CODES) this.updatePreference({ preference: 'enicsCadenceCodes', value: obj.ENICS_CADENCE_CODES })
			if (obj.ENICS_STATE_OF_RESIDENCE_CODES) this.updatePreference({ preference: 'enicsStateOfResidenceCodes', value: obj.ENICS_STATE_OF_RESIDENCE_CODES })
			if (obj.ENABLE_SCREEN_CAPTURE_SIGNATURE) this.enableSignOnScreen = obj.ENABLE_SCREEN_CAPTURE_SIGNATURE == "1"
			this.logoSrc = obj.STORE_LOGO
		}).catch(err => {
			console.log(err);
		})
		if (this.$route.query.section && this.$route.query.id) {
			this.apiCallLocal('get_item_ffl_log_book_form', { ffl_log_book_form_id: this.$route.query.id }).then(obj => {
				this.searchMessageCorrectPending = obj.message
				if (obj.log_book_form) {
					this.assignForm(obj.log_book_form)
					this.contact_data = obj.contact_data
					// prepopulate customer data as a convenience if in dev mode
					if (document.location.hostname.indexOf('.test') > -1) {
						this.form.form_data.section_b.first_name = this.contact_data.first_name
						this.form.form_data.section_b.middle_name = this.contact_data.middle_name
						this.form.form_data.section_b.last_name = this.contact_data.last_name
						this.form.form_data.section_b.address_1 = this.contact_data.address_1
						this.form.form_data.section_b.city = this.contact_data.city
						this.form.form_data.section_b.state = this.contact_data.state
						this.form.form_data.section_b.zip_code = this.contact_data.zip_code
						this.form.form_data.section_b.birthdate = this.contact_data.birthdate
					}
					this.user = this.getUser
					this.enableSignOnScreen = obj.enable_screen_capture_signature
				} else {
					this.message = '4473 not found.'
				}
			})
		} else {
			this.doLogout()
		}
	},
	watch: {
		'form_data.middle_name_blank': function(data) {
			if (data === true) {
				this.toggleInitial('contact', 'middle_name', data)
				this.toggleInitial('form_data', 'middle_initial', data)
			}
		},
		'form_data.customerValues.CITIZEN_STATUS_CODE': function(data) {
			this.form_data.customerValues.CITIZEN_COUNTRY_CODE = (data == 'C') ? 'United States of America' : null
		},
		'form.form_data.section_b.citizen_status_code': function(data) {
			this.form.form_data.section_b.exc_code = null
		},
		formOption(newVal) {
			if (newVal && !this.form.form_data.section_d) {
				setTimeout(() => {
					this.initializeSignaturePad()
				}, 2000)
			}
		}
	},
	computed: {
		...mapState({
            getEnicsCadenceCodes: (state, getters) => getters['logbooks/getEnicsCadenceCodes'],
            getEnicsStateOfResidenceCodes: (state, getters) => getters['logbooks/getEnicsStateOfResidenceCodes']
        }),
		today() {
			return this.$moment().format('YYYY-MM-DD')
		},
		sectionBComplete() {
			if (this.$route.query.section == 'd') {
				return true
			} else {
				return this.form.section_completed != 'A' && this.form.internal_use_only !== 1
			}
		},
		isCitizen() {
			if (this.form.form_data.section_b.citizen_status_code == 'C') { //  || this.form.form_data.section_b.legal_alien == 'no'
				return true
			}
			// if (this.form.form_data.section_b.mnu_type_code1 == 'AR' || this.form.form_data.section_b.mnu_type_code1 == 'USCIS') {
			// 	return true
			// }
			return false
		},
        nicsDelayed() {
            if (this.form.form_data.section_c.nics_initial_response == 'Delayed' && !this.form.form_data.section_e.not_transferred) {
                if (!this.form.form_data.section_c.nics_later_response_proceed && !this.form.form_data.section_c.nics_later_response_denied && !this.form.form_data.section_c.nics_later_response_canceled && !this.form.form_data.section_c.nics_later_response_no_response && !this.form.form_data.section_c.nics_later_response_overturned) {
                    return true
                }
            }
        }
	},
	methods: {
		...mapActions('logbooks', [
            'updatePreference',
        ]),
		apiCallLocal(action, data) {
			if (!this.apiEndpoint) {
				let developmentEnvironment = process.env.NODE_ENV !== 'production'
				let sandboxEnvironment = document.location.hostname.indexOf('sandbox') > -1
				let hostname = ''
				if (developmentEnvironment) {
				    hostname = 'cdsapi.test'
				} else if (sandboxEnvironment) {
				    hostname = 'api.cdssandbox.com'
				} else {
				    //hostname = 'api.connecteddatasolutions.com'
    				hostname = document.location.hostname + '/api'
				}
				this.apiEndpoint = 'https://' + hostname + '/api.php?action='
			}
			if (!data) { data = {} }
			data.source = 'LOGBOOKS'
            data.fd_token = getCookie('dashboard_token')
			if (!data.fd_token) {
            	data.fd_token = sessionStorage.getItem('fd_token')
			}
			data.kiosk_mode = true
			return new Promise((resolve, reject) => {
	            let headers = {
	                method: 'post',
	                body: JSON.stringify(data),
	                credentials: 'include'
	            }
	            fetch(this.apiEndpoint + action, headers).then(function(response) {
	                return response.json()
	            }).then(obj => {
                    resolve(obj)
	            }).catch(error => {
	                reject(error)
	            })
	        })
		},
		doLogin() {
    		if (!this.username || !this.password) return
		    this.message = ''
			this.loading = true
    		this.apiCallLocal('login', { user_name: this.username, password: this.password }).then(obj => {
				this.loading = false
    			if (obj.status == 'success') {
					this.user = obj.user
					if (obj.user.token) {
						sessionStorage.setItem('fd_token', obj.user.token)
					}
					this.apiCallLocal('get_item_preference', { preference_type: 'system', preference_code: 'ENICS_CADENCE_CODES,ENICS_STATE_OF_RESIDENCE_CODES' }).then(obj => {
						if (obj.ENICS_CADENCE_CODES) this.updatePreference({ preference: 'enicsCadenceCodes', value: obj.ENICS_CADENCE_CODES })
						if (obj.ENICS_STATE_OF_RESIDENCE_CODES) this.updatePreference({ preference: 'enicsStateOfResidenceCodes', value: obj.ENICS_STATE_OF_RESIDENCE_CODES })
					}).catch(err => {
						console.log(err);
					})
					this.apiCallLocal('get_item_preference', { preference_type: 'client', preference_code: 'ENABLE_SCREEN_CAPTURE_SIGNATURE' }).then(obj => {
						if (obj.ENABLE_SCREEN_CAPTURE_SIGNATURE) this.enableSignOnScreen = obj.ENABLE_SCREEN_CAPTURE_SIGNATURE == "1"
					}).catch(err => {
						console.log(err);
					})
    			} else {
    				this.message = obj.message
    			}
    		})
    	},
    	doLogout() {
			this.username = ''
			this.password = ''
			this.user = {
				user_id: '',
				user_name: '',
				user_type_code: ''
			}
    	},
		fetchClient() {
			// TO-DO: If we are on ffloffice.com, do we get the client back from login
			// or do we send something with the get_client request to identify the client? user_id?
			let data = {
				source: 'LOGBOOKS'
			}
			this.apiCallLocal('get_client', data).then(obj => {
				this.client = obj.client
				this.client_logo_src = this.client.logo_src || null
			}).catch(err => {
				console.log(err)
			})
		},
		searchForms(which) {
			let searchText = ''
			if (which == 'A') {
				 if (!this.search_section_a_text) {
					 return
				 }
				 this.sectionAForms = []
				 this.searchMessageSectionA = ''
				 searchText = this.search_section_a_text
			}
			if (which == 'C') {
				 if (!this.search_section_c_text) {
					 return
				 }
				 this.sectionCForms = []
				 this.searchMessageSectionC = ''
				 searchText = this.search_section_c_text
			}
			this.apiCallLocal('get_list_ffl_log_book_forms', { form_type: "4473", contact_search_term: searchText, section_completed: which, context: 'CUSTOMER' }).then(obj => {
				if (obj.status == 'error') {
					this.enableSignOnScreen = obj.enable_screen_capture_signature
					if (which == 'A') {
						this.searchMessageSectionA = obj.message
					} else {
						this.searchMessageSectionC = obj.message
					}
				} else if (obj.log_book_forms.length > 0) {
					if (which == 'A') {
						this.sectionAForms = obj.log_book_forms
					} else {
						this.sectionCForms = obj.log_book_forms
					}
				} else {
					if (which == 'A') {
						this.searchMessageSectionA = 'No matching Section A complete forms found.'
					} else {
						this.searchMessageSectionC = 'No matching Section C complete forms found.'
					}
				}
			})
		},
		getCorrectPendingForms() {
			this.gettingCorrectPendingForms = true
			this.correctPendingForms = []
			this.apiCallLocal('get_list_ffl_log_book_forms', { form_type: "4473", internal_use_only: true }).then(obj => {
				this.searchMessageCorrectPending = obj.message
				if (obj.log_book_forms.length > 0) {
					this.correctPendingForms = obj.log_book_forms
				} else {
					this.searchMessageCorrectPending = 'No pending correction forms found.'
				}
			})
		},
		assignForm(formData) {
			this.formId = formData.ffl_log_book_form_id
			this.form = formData
			if (this.sectionBComplete) {
				this.form.form_data.section_d.buyer_recertification_date ? this.form.form_data.section_d.buyer_recertification_date : this.today
			} else {
        		this.form.form_data.section_b.signed_date ? this.form.form_data.section_b.signed_date : this.today
			}
			this.formOption = 'existing'
			this.message = ''
			this.formIncomplete = true
		},
		// fullName(contact) {
		// 	if (!contact) return null
		// 	if (contact.full_name) {
		// 		return contact.full_name
		// 	} else {
		// 		return (contact.company_name) ? contact.company_name : contact.first_name + " " + contact.last_name
		// 	}
		// },
		initializeSignaturePad() {
			if (this.nicsDelayed) { return }
			if (this.signaturePadOnScreen) {
				let canvas = null
				if (this.sectionBComplete) {
            		this.capturingSectionDSignature = true
					canvas = document.getElementById("section_d_buyers_signature_pad")
				} else {
            		this.capturingSignature = true
					canvas = document.getElementById("buyers_signature_pad")
				}
				this.signaturePad = new SignaturePad(canvas, { minWidth: 2, maxWidth: 2 })
			} else {
				var prevPoint;
				if (this.sectionBComplete) {
					this.signaturePad = document.getElementById("section_d_buyers_signature_pad")
				} else {
					this.signaturePad = document.getElementById("buyers_signature_pad")
				}
				this.scriptel = new ScriptelEasyScript();
				this.scriptel.configurationCallback = (evt,chr) => {
					if(chr==='"') {
						this.scriptel.fromKeyboardSpec = "ca-fr"
					} else {
						this.scriptel.fromKeyboardSpec = "us-basic"
					}
				};
				this.scriptel.addSignatureListener(document);
				this.scriptel.registerStreamingCallback((e) => {
					switch (e.type) {
						case "ScriptelSignatureMetaData":
							this.clearCanvas();
							break;
						case "ScriptelNewStroke":
							prevPoint = null;
							break;
						case "ScriptelCoordinate":
							if (prevPoint != null) {
								this.scriptel.drawSegmentOnCanvas(prevPoint, e, this.signaturePad,{"strokeStyle":"black","lineWidth":2});
							}
							prevPoint = e;
							break;
						case "ScriptelCancelSignature":
							this.clearCanvas();
							prevPoint = null;
							break;
						case "ScriptelSignatureComplete":
							this.saveSignature()
							break;
					}
				});
			}
		},
        captureBuyersSignature(onScreen = false) {
			if (this.nicsDelayed) { return }
			if (this.signaturePadOnScreen && this.signaturePad) { this.signaturePad.clear() }
			this.signaturePadOnScreen = onScreen
			this.activatingSignaturePad = true
			if (!this.sectionBComplete && !this.validateSectionB()) {
				this.activatingSignaturePad = false
				return
			}
			this.activatingSignaturePad = false
			if (this.sectionBComplete) {
            	this.capturingSectionDSignature = true
            	this.savedSignature = this.form.form_data.section_d.buyer_recertification_signature
				this.form.form_data.section_d.buyer_recertification_signature = null
	        	setTimeout(() => {
	        		this.initializeSignaturePad()
	        	}, 500)
			} else {
            	this.capturingSignature = true
            	this.savedSignature = this.form.form_data.section_b.signature
        		this.form.form_data.section_b.signature = null
	        	setTimeout(() => {
	        		this.initializeSignaturePad()
	        	}, 500)
			}
        },
        restoreBuyersSignature() {
            this.capturingSignature = false
            this.form.form_data.signature = this.savedSignature
        },
		saveSignature() {
			this.signatureSaved = true
			this.capturingSignature = false
			this.capturingSectionDSignature = false
			if (this.signaturePadOnScreen) {
				// applies to signing on screen
				if (this.sectionBComplete) {
					this.cropCanvasImage(document.getElementById("section_d_buyers_signature_pad").getContext("2d"))
				} else {
					this.cropCanvasImage(document.getElementById("buyers_signature_pad").getContext("2d"))
				}
			} else {
				// applies to signature pad
				this.cropCanvasImage(this.signaturePad.getContext("2d"))
			}
			if (this.sectionBComplete) {
				this.form.form_data.section_d.buyer_recertification_signature = this.signaturePad.toDataURL()
			} else {
				this.form.form_data.section_b.signature = this.signaturePad.toDataURL()
			}
		},
		cropCanvasImage(ctx) {
			var canvas = ctx.canvas, 
				w = canvas.width, h = canvas.height,
				pix = {x:[], y:[]},
				imageData = ctx.getImageData(0,0,canvas.width,canvas.height),
				x, y, index;
			for (y = 0; y < h; y++) {
				for (x = 0; x < w; x++) {
				index = (y * w + x) * 4;
				if (imageData.data[index+3] > 0) {
					pix.x.push(x);
					pix.y.push(y);
				} 
				}
			}
			pix.x.sort(function(a,b){return a-b});
			pix.y.sort(function(a,b){return a-b});
			var n = pix.x.length-1;
			w = 1 + pix.x[n] - pix.x[0];
			h = 1 + pix.y[n] - pix.y[0];
			var cut = ctx.getImageData(pix.x[0], pix.y[0], w, h);
			canvas.width = w;
			canvas.height = h;
			ctx.putImageData(cut, 0, 0);
		},
		clearCanvas() {
			if (this.signaturePadOnScreen && this.signaturePad) {
				this.signaturePad.clear()
			} else {
				//Get the graphics context of the canvas.
				var ctx = this.signaturePad.getContext("2d");
				//Clear the canvas and fill with the background color:
				ctx.clearRect(0,0,this.signaturePad.width,this.signaturePad.height);
			}
			this.signatureSaved = false
			if (this.sectionBComplete) {
				this.form.form_data.section_d.buyer_recertification_signature = null
			} else {
				this.form.form_data.section_b.signature = null
			}
        },
        cancelSignature() {
			this.signatureSaved = false
			if (this.sectionBComplete) {
				this.capturingSectionDSignature = false
				this.form.form_data.section_d.buyer_recertification_signature = null
			} else {
        		this.capturingSignature = false
        		this.form.form_data.section_b.signature = null
			}
        	setTimeout(() => {
        		this.initializeSignaturePad()
        	}, 500)
        },
		newForm() {
			this.formOption = 'new'
			this.initializeSignaturePad()
		},
		doFormNew() {
			this.formOption = 'new'
			this.formIncomplete = true
		},
		updateState(state) {
			this.contact.state = state
		},
		updateBirthplace(state) {
			this.form_data.customerValues.POB_CODE = state
		},
        validateSectionB() {
			// explicit checks allow us to keep validation in order of display fields
			if (!this.form.form_data.section_b.last_name) {
				this.scroll('last_name')
				return false
			} else {
				this.removeError('last_name')
			}
			if (!this.form.form_data.section_b.first_name) {
				this.scroll('first_name')
				return false
			} else {
				this.removeError('first_name')
			}
			if (!this.form.form_data.section_b.middle_name && !this.form.form_data.section_b.no_middle_name) {
				this.scroll('middle_name')
				return false
			} else {
				this.removeError('middle_name')
			}
			if (!this.form.form_data.section_b.address_1) {
				this.scroll('address_1')
				return false
			} else {
				this.removeError('address_1')
			}
			if (!this.form.form_data.section_b.city) {
				this.scroll('city')
				return false
			} else {
				this.removeError('city')
			}
			if (!this.form.form_data.section_b.county) {
				this.scroll('county')
				return false
			} else {
				this.removeError('county')
			}
			if (!this.form.form_data.section_b.state) {
				this.scroll('state')
				return false
			} else {
				this.removeError('state')
			}
			if (!this.form.form_data.section_b.zip_code) {
				this.scroll('zip_code')
				return false
			} else {
				this.removeError('zip_code')
			}
			if (!this.form.form_data.section_b.birth_city && !this.form.form_data.section_b.foreign_country) {
				this.scroll('place_of_birth')
				return false
			} else {
				this.removeError('place_of_birth')
			}
			if (!this.form.form_data.section_b.pob_code && !this.form.form_data.section_b.foreign_country) {
				this.scroll('place_of_birth_state')
				return false
			} else {
				this.removeError('place_of_birth_state')
			}
			if (!this.form.form_data.section_b.feet) {
				this.scroll('feet')
				return false
			} else {
				this.removeError('feet')
			}
			if (!this.form.form_data.section_b.inches) {
				this.scroll('inches')
				return false
			} else {
				this.removeError('inches')
			}
			if (!this.form.form_data.section_b.weight) {
				this.scroll('weight')
				return false
			} else {
				this.removeError('weight')
			}
			if (!this.form.form_data.section_b.gender_code) {
				this.scroll('sex')
				return false
			} else {
				this.removeError('sex')
			}
			if (!this.form.form_data.section_b.birthdate) {
				this.scroll('birthdate')
				return false
			} else {
				this.removeError('birthdate')
			}
			if (!this.form.form_data.section_b.ethnicity) {
				this.scroll('ethnicity')
				return false
			} else {
				this.removeError('ethnicity')
			}
			let raceIsComplete = []
			for (var key in this.form.form_data.section_b.customer_race) {
				if (!this.form.form_data.section_b.customer_race.hasOwnProperty(key)) continue
				if (this.form.form_data.section_b.customer_race[key]) raceIsComplete.push(key)
			}
			if (raceIsComplete.length == 0) {
				this.scroll('race')
				return false
			} else {
				this.removeError('race')
			}
			// NOTE: actual_buyer can be left blank!
			// if (!this.form.form_data.section_b.actual_buyer) {
			// 	this.scroll('actual_buyer')
			// 	return false
			// } else {
			// 	this.removeError('actual_buyer')
			// }
			if (!this.form.form_data.section_b.under_indictment) {
				this.scroll('under_indictment')
				return false
			} else {
				this.removeError('under_indictment')
			}
			if (!this.form.form_data.section_b.convict) {
				this.scroll('convict')
				return false
			} else {
				this.removeError('convict')
			}
			if (!this.form.form_data.section_b.fugitive) {
				this.scroll('fugitive')
				return false
			} else {
				this.removeError('fugitive')
			}
			if (!this.form.form_data.section_b.addict) {
				this.scroll('addict')
				return false
			} else {
				this.removeError('addict')
			}
			if (!this.form.form_data.section_b.mental) {
				this.scroll('mental')
				return false
			} else {
				this.removeError('mental')
			}
			if (!this.form.form_data.section_b.dishonorable_discharge) {
				this.scroll('dishonorable_discharge')
				return false
			} else {
				this.removeError('dishonorable_discharge')
			}
			if (!this.form.form_data.section_b.restraining_order) {
				this.scroll('restraining_order')
				return false
			} else {
				this.removeError('restraining_order')
			}
			if (!this.form.form_data.section_b.domestic_violence) {
				this.scroll('domestic_violence')
				return false
			} else {
				this.removeError('domestic_violence')
			}
			// 12.a.
			if (!this.form.form_data.section_b.citizen_status_code) {
				this.scroll('origin_country')
				return false
			} else {
				this.removeError('origin_country')
			}
			// 12a other option
			if (this.form.form_data.section_b.citizen_status_code == 'F' && !this.form.form_data.section_b.citizen_country_code) {
				this.scroll('origin_country')
				return false
			} else {
				this.removeError('origin_country')
			}
			if (this.form.form_data.section_b.citizen_status_code == 'C') {
				this.form.form_data.section_b.citizen_country_code = null
				this.form.form_data.section_b.citizen_country_code_2 = null
				this.form.form_data.section_b.citizen_country_code_3 = null
			} else {
				this.form.form_data.section_b.origin_country = this.COUNTRIES_LIST[this.form.form_data.section_b.citizen_country_code]
				this.form.form_data.section_b.origin_country += (this.form.form_data.section_b.citizen_country_code_2) ? ", " + this.COUNTRIES_LIST[this.form.form_data.section_b.citizen_country_code_2] : ""
				this.form.form_data.section_b.origin_country += (this.form.form_data.section_b.citizen_country_code_3) ? ", " + this.COUNTRIES_LIST[this.form.form_data.section_b.citizen_country_code_3] : ""
			}
			if (!this.form.form_data.section_b.renounced_citizenship) {
				this.scroll('renounced_citizenship')
				return false
			} else {
				this.removeError('renounced_citizenship')
			}
			if (!this.form.form_data.section_b.illegal_alien) {
				this.scroll('illegal_alien')
				return false
			} else {
				this.removeError('illegal_alien')
			}
			if (!this.form.form_data.section_b.legal_alien) {
				this.scroll('legal_alien')
				return false
			} else {
				this.removeError('legal_alien')
			}
			// if (!this.isCitizen && !this.form.form_data.section_b.exc_code) {
			// 	this.scroll('exc_code')
			// 	return false
			// } else {
			// 	this.removeError('exc_code')
			// }
			if (this.form.form_data.section_b.citizen_status_code == 'F' && !this.form.form_data.section_b.mnu1) {
				this.scroll('mnu1')
				return false
			} else {
				this.removeError('mnu1')
			}
			if (!this.isCitizen) {
				if (this.form.form_data.section_b.mnu1 && !this.form.form_data.section_b.mnu_type_code1) {
					this.scroll('mnu_type_code1')
					return false
				} else {
					this.removeError('mnu_type_code1')
				}
			}
			if (!this.form.form_data.section_b.i_certify) {
				this.scroll('i_certify')
				return false
			} else {
				this.removeError('i_certify')
			}
			// validate before they actaully sign because after signature the form will be locked
			if (this.activatingSignaturePad) {
				return true
			}
			if (!this.form.form_data.section_b.signed_date) {
				this.scroll('signed_date')
				return false
			} else {
				this.removeError('signed_date')
			}

			// All good, so clean up data and submit the form!
			if (this.form.form_data.section_b.foreign_country && !this.form.form_data.section_b.birth_city) {
				this.form.form_data.section_b.pob_code = this.form.form_data.section_b.foreign_country
			}
			if (this.form.form_data.section_b.feet && !this.form.form_data.section_b.inches) {
				this.form.form_data.section_b.inches = ""
			}
            // if (this.form.internal_use_only !== 1) this.sendForm()
            // else this.moveForm()
			return true
		},
		sendForm() {
			this.loading = true
			this.message = ''
			let data = {
				ffl_log_book_form_id: this.formId,
				form: {
					form_data: this.form.form_data,
				},
				contact_id: this.form.contact_id,
			}
			if (!this.sectionBComplete) {
				// if (document.location.hostname.indexOf('.test') > -1) {
				// 	console.log('dev environment, signature not required')
				// } else if (!this.form.form_data.section_b.signature) {
				// 	return false
				// }

				if (!this.form.form_data.section_b.signature) {
					this.message = 'Signature is required'
					this.loading = false
					return false
				}

				// recreate the contact data from form_data
				data.form_section = 'section_b'
				data.contact_data = this.contact_data // start with the full contact object return from get_item_ffl_log_book_form so we don't overwrite email address and other "extra" fields
				data.contact_data.first_name = this.form.form_data.section_b.first_name
				data.contact_data.middle_name = this.form.form_data.section_b.middle_name
				data.contact_data.last_name = this.form.form_data.section_b.last_name
				data.contact_data.address_1 = this.form.form_data.section_b.address_1
				data.contact_data.city = this.form.form_data.section_b.city
				data.contact_data.state = this.form.form_data.section_b.state
				data.contact_data.zip_code = this.form.form_data.section_b.zip_code
				data.contact_data.birthdate = this.form.form_data.section_b.birthdate
			} else {
				// if (document.location.hostname.indexOf('.test') > -1) {
				// 	console.log('dev environment, signature not required')
				// } else if (!this.form.form_data.section_d.buyer_recertification_signature) {
				// 	return false
				// }

				if (!this.form.form_data.section_d.buyer_recertification_signature) {
					this.message = 'Signature is required'
					this.loading = false
					return false
				}

				data.form_section = 'section_d'
			}
			// send to server
			this.apiCallLocal('save_4473_section', data).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.formIncomplete = false
					this.formId = obj.ffl_log_book_form_id
				} else {
					this.message = obj.message
				}
			})
		},
        moveForm() {
            if (this.userInitials.length < 2) return
			this.loading = true
			let data = {
				old_ffl_log_book_form_id: this.formId,
				form: {
					form_data: this.form.form_data,
				},
				contact_id: this.form.contact_id,
                user_initials: this.userInitials
			}
			// recreate the contact data from form_data
			// NOTE: let's make consistent use of a contact_data object
			if (this.$route.query.section == 'd') {
				data.form_section = 'section_d'
			} else {
				data.form_section = 'section_b'
			}
			data.contact = {
				contact_id: this.form.contact_id,
				first_name: this.form.form_data.section_b.first_name,
				middle_name: this.form.form_data.section_b.middle_name,
				last_name: this.form.form_data.section_b.last_name,
				address_1: this.form.form_data.section_b.address_1,
				city: this.form.form_data.section_b.city,
				state: this.form.form_data.section_b.state,
				zip_code: this.form.form_data.section_b.zip_code,
				birthdate: this.form.form_data.section_b.birthdate
			}
			// send to server
			this.apiCallLocal('move_item_4473', data).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.formIncomplete = false
					this.formId = obj.ffl_log_book_form_id
				} else {
					this.message = obj.message
				}
			})
		},
		cancelMoveForm() {
			this.apiCall({ destination: 'save_4473_internal_use_only', data: { ffl_log_book_form_id: this.formId, current_internal_use_only: 1 } }).then((obj) => {
				this.$router.push('/logbooks/4473/' + this.formId)
			}).catch((err) => {
				console.log(err)
			})
		},
		resetForm() {
			// go to kiosk login screen
			this.$router.push('/logbooks/customer-4473')
		},
		scroll(id) {
			var el = this.$el.querySelector('#' + id)
			var top = el.offsetTop;
			var scrollDiv = this.$el.querySelector('#main-form-container')
		    scrollDiv.scroll({ top: top, left: 0, behavior: "smooth"})
		    el.classList.add('error')
		},
		removeError(id) {
			var el = this.$el.querySelector('#' + id)
			if (el.classList.contains('error')) {
				el.classList.remove('error')
			}
		},
		toggleHelp(index) {
			if (this.showHelp.indexOf(index) > -1) {
				this.showHelp.splice(this.showHelp.indexOf(index), 1)
			} else {
				this.showHelp.push(index)
			}
		},
		toggleInitial(object, value, data) {
			if (data != '' && this[object][value] != '') {
				this[object][value] = ''
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../detail-4473.scss";
.main {
	top: -5em; // offset normal .container top
}
.main-form-container {
    position: relative;
	// match height of .container.report-list
	height: calc(100vh - 10rem);
	overflow-y: scroll;
}
.page-header {
	display: grid;
	grid-template-columns: 1fr 2fr;
	align-items: baseline;
	border-bottom: 1px solid #666;
}
.page-header img {
	margin: 0.5em 0.5em 0.5em 0;
	max-height: 2.5em;
}
.page-header h1 {
	text-align: right;
	font-family: 'Oswald', sans-serif;
	text-transform: uppercase;
	font-weight: 400;
	margin: 0.5em 0 0.5em 1em;
	color: #333;
	font-size: 1.25em;
	@media all and (min-width: 1024px) {
		font-size: 1.5em;
	}
}

.form-options {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 3rem;
    justify-content: center;
    width: 75%;
    margin: 3rem auto;
}

.login, .form-options {
	padding: 0 0 3em 0;
	h1, h2 {
		margin: 0.25em 0;
		font-weight: 500;
	    font-size: 1.5em;
	    background: none;
	    text-transform: none;
	    padding: 0;
	}
	.get-correct-pending-link {
		cursor: pointer;
	}
	.get-correct-pending-link:hover {
		color: #4abdac;
	}
}
.login {
	margin: 3em auto 4em auto;
	width: 30%;
}
.login label {
	margin-top: 1em;
	display: inline-block;
}

.form-complete {
    width: 45%;
    margin: 2em auto;
    padding: 6em 0;
    text-align: center;
}
.form-complete a {
    text-decoration: none;
    height: 1em;
}

.user-initials {
    display: grid;
	grid-template-columns: 5em 1fr;
	grid-column-gap: 1em;
	align-items: center;
}
</style>
